import { FC, useState } from 'react'
import {
  Grid,
  Typography,
  ListItem,
  Tooltip,
  IconButton,
  useTheme,
} from '@mui/material'
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone'
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone'
import PrintIcon from '@mui/icons-material/Print'
import ShareIcon from '@mui/icons-material/Share'
import DeleteIcon from '@mui/icons-material/Delete'
import EditCalendarIcon from '@mui/icons-material/EditCalendar'

import { EditItem } from './EditItem'
import { DeleteItem } from './DeleteItem'
import BorderColorIcon from '@mui/icons-material/BorderColor'

import { TabsEnums } from '../../../components'
import { ItemEntry, EntryType } from '../../../services'
import './slips_style.css'
import { getShortFormattedDate } from 'src/utils'

const ItemName: FC<{ name: string; id?: string }> = ({ name, id }) => {
  return (
    <Typography
      id="item_name"
      data-cy={id}
      variant="body2"
      sx={{
        py: 0,
        pl: 3,
        m: 1.2,
      }}
    >
      {name}
    </Typography>
  )
}

interface LeftListItemComponentProps {
  item: ItemEntry
  componentName: TabsEnums
  bgcolor?: string
  accountType?: string
  totalWeight?: string
}

export const LeftListItemComponent: FC<LeftListItemComponentProps> = ({
  item,
  componentName,
  bgcolor,
  accountType,
  totalWeight
}) => {
  const theme = useTheme()

  const [editItem, openEditItem] = useState<boolean>(false)
  const [deleteItem, openDeleteItem] = useState<boolean>(false)
  const testIdPrefix = `id_${item.itemName}`
  return (
    <ListItem
      id="slip_row"
      
      sx={{
        pt: 0.3,
        pb: 0.3,
        bgcolor: item.id < 0 ? '#d1d2e1ff' : bgcolor
      }}
      key={item.id}
    >
      <Grid container sx={{ p: 0 }} alignItems="center" justifyContent="center">
        <Grid item xs={2.5} sx={{ alignItems: 'center' }}>
          <div
            style={{
              height: 10,
              width: 10,
              borderRadius: 5,
              backgroundColor: item.barColorCode,
              marginLeft: 20,
              position: 'absolute',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
          <ItemName name={item.itemName} id={`${testIdPrefix}_name`} />
        </Grid>

        <Grid item xs={2} sx={{ textAlign: 'right', pr: 2 }}>
          <Typography
            id="item_out_count"
            data-cy={`${testIdPrefix}_out`}
            variant="body2"
          >
            {item.outCount}
          </Typography>
        </Grid>

        <Grid item xs={2} sx={{ textAlign: 'right', pr: 2 }}>
          <Typography
            data-cy={`${testIdPrefix}_in`}
            id="item_in_count"
            variant="body2"
          >
            {item.inExcludingLostCount ?? item.inCount}
          </Typography>
        </Grid>

        <Grid item xs={1.5} sx={{ textAlign: 'right', pr: 2 }}>
          <Typography variant="body2">
            {item.lostCount ?? 0}
          </Typography>
        </Grid>

        <Grid item xs={2} sx={{ textAlign: 'right', pr: 2 }}>
          <Typography
            data-cy={`${testIdPrefix}_left`}
            variant="body2"
          >
            {item.quantity}
          </Typography>
        </Grid>
        <Grid item xs={2} sx={{ textAlign: 'right', pr: 2 }}>
          <Typography variant="body2">
            {item.itemName === 'SUM'
              ? totalWeight
              : item.itemName === 'TOTAL' || item.itemName?.startsWith('TOTAL ')
                ? '-'
                : item.weight != null
                  ? item.weight + ' Kg'
                  : '-'}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  )
}
